<template>
  <div class="home">
    <button @click="$adal.login()">sign in</button>
    <button @click="$adal.logout()">sign out</button>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {},
  mounted() {}
};
</script>
